var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":"success"}},[_c('vs-icon',{staticStyle:{"font-size":"1.5rem"},attrs:{"title":_vm.chipText(_vm.params.value),"icon":_vm.getIcon(_vm.params.value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }